import React, { Component } from "react";

const withFocus = (BaseComponent) =>
    class extends Component {
        static displayName = `withFocus${BaseComponent.name}`;

        state = {
            isFocused: false,
        };

        toggleIsFocused = () => {
            this.setState((prevState) => ({ isFocused: !prevState.isFocused }));
        };

        render() {
            const { isFocused } = this.state;
            return <BaseComponent {...this.props} toggleIsFocused={this.toggleIsFocused} isFocused={isFocused} />;
        }
    };

export default withFocus;
